<template>
  <div class="inquiry_list home_page">
    <Search
      ref="search"
      :searchConfig="tableConfig"
      @doSearch="getDataList(1)"
      :resetEvent="true"
      @reset="resetDoSearch(dataForm)"
    >
      <template :slot="'btns'">
        <el-button
          type="primary"
          class="primary"
          size="small"
          @click="handleSaveReceive"
          >新增</el-button
        >
        <el-button
          @click="download"
          :loading="loading"
          size="small"
          >导出</el-button
        >
        <ExportCom url="/front/oms/shopping/invoiceApply/v1/invoiceListExportHistory" />
      </template>
    </Search>
    <div class="table">
      <el-table
        :data="dataList"
        key="inquiryTable"
        v-loading="dataLoading"
        border
      >
        <template slot="empty">
          <img src="@/assets/img/good/noGood.png">
          <div>暂无数据</div>
        </template>
        <el-table-column
          type="index"
          header-align="center"
          align="center"
          width="50"
        ></el-table-column>
        <el-table-column
          prop="invoiceApplyNo"
          header-align="center"
          align="center"
          width="125px"
          label="开票申请单号"
        >
          <template slot-scope="scope">
            <a @click="detailHandle(scope.row)">
              {{ scope.row.invoiceApplyNo }}
            </a>
            <img
              width="14px"
              style="cursor: pointer"
              v-clipboard:copy="scope.row.invoiceApplyNo"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
              src="@/assets/img/copy.png"
              alt="复制"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="orderCode"
          header-align="center"
          align="center"
          show-overflow-tooltip
          label="订单编号"
        ></el-table-column>
        <el-table-column
          prop="companyName"
          header-align="center"
          align="center"
          show-overflow-tooltip
          label="客户企业"
        ></el-table-column>
        <el-table-column
          prop="invoiceApplySubStatusText"
          header-align="center"
          align="center"
          label="邮寄状态"
        ></el-table-column>
        <el-table-column
          prop="invoiceAmount"
          header-align="center"
          align="right"
          label="申请总额"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          header-align="center"
          align="center"
          show-overflow-tooltip
          label="制单时间"
        ></el-table-column>
        <el-table-column
          prop="createUserName"
          header-align="center"
          align="center"
          label="申请人"
        ></el-table-column>
        <el-table-column
          prop="status"
          header-align="center"
          align="center"
          label="状态"
          width="100px"
        >
          <template slot-scope="scope">
            {{ scope.row.invoiceApplyStatusText || '-' }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="dataForm.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="dataForm.limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="currentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import Search from '@/components/search/index'
import ExportCom from '@/components/exportCom/index2'
import { Base64 } from 'js-base64'
export default {
  name: 'afterSalesList',
  components: {
    Search,
    ExportCom
  },
  data () {
    return {
      dataLoading: false,
      options: [
        // 1待受理 2已驳回 3处理中 4已取消 5已完成
        {
          value: '1',
          label: '待受理'
        },
        {
          value: '2',
          label: '已驳回'
        },
        {
          value: '3',
          label: '处理中'
        },
        {
          value: '4',
          label: '已取消'
        },
        {
          value: '5',
          label: '已完成'
        }
      ],
      dataForm: {
        page: 1,
        limit: 10,
        companyIds: []
      },
      total: 0,
      dataList: [],
      tableConfig: {
        params: [
          {
            prop: 'invoiceApplyNo',
            label: '开票申请单号',
            placeholder: '开票申请单号'
          },
          {
            prop: 'orderCode',
            label: '订单编号',
            placeholder: '订单编号'
          },
          {
            prop: 'companyName',
            label: '客户企业',
            placeholder: '客户企业',
            hideInSearch: true
          },
          {
            prop: 'invoiceApplySubStatusList',
            label: '邮寄状态',
            searchType: 'multipleSelect',
            isSlot: true,
            searchValueType: 'array',
            props: {
              label: 'value',
              value: 'code'
            },
            options: window.SITE_CONFIG.dictList.INVOICE_APPLY_SUB_STATUS
          },
          {
            prop: 'createUserName',
            label: '申请人',
            placeholder: '申请人'
          },
          {
            prop: 'invoiceApplyStatus',
            label: '状态',
            placeholder: '状态',
            searchType: 'tabSelect',
            props: {
              label: 'label',
              value: 'name'
            },
            options: [...(window.SITE_CONFIG.dictList.FRONT_USER_INVOICE_APPLY_STATUS || [])]
          }
        ],
        extra: {} // 额外的参数 搜索的条件
      },
      companyList: [],
      downloadLoading: false,
      loading: false
    }
  },
  mounted () {
    console.log(this.$store.state)
    this.dataForm.companyIds = [this.$store.state.user.defaultCompanyId]
    this.getDataList(1)
  },
  methods: {
    getDataList () {
      this.getInquriyDataList(1)
    },
    // 重置
    reset () {
      this.dataForm = {
        page: 1,
        limit: 10,
        companyList: [],
        companyIds: [this.$store.state.user.defaultCompanyId]
      }
      this.getDataList(1)
    },
    // 获取列表数据
    getInquriyDataList (page = this.dataForm.page) {
      this.dataForm.page = page
      if (this.dataLoading) {
        return false
      }
      this.dataLoading = true
      let obj = this.getParams()
      this.$http
        .post(`/front/oms/shopping/invoiceApply/list`, obj)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            this.total = 0
            this.dataList = []
            return false
          }
          this.total = res.data.total - 0
          this.dataList = res.data.records || []
        })
        .catch(() => {
          this.dataList = []
          this.total = 0
        })
        .finally(() => {
          this.dataLoading = false
        })
    },
    // 更改分页条数
    pageSizeChangeHandle (val) {
      this.dataForm.limit = val
      this.getDataList(1)
    },
    currentChange (val) {
      this.dataForm.page = val
      this.getInquriyDataList()
    },
    // 复制成功
    onCopy () {
      this.$message.success('复制成功')
    },
    // 复制失败
    onError () {
      this.$message.error('复制失败')
    },
    // 查看详情
    detailHandle (row) {
      const srcInfo = this.$router.resolve({
        path: '/personalCenter/order-invoice-detail',
        query: {
          invoiceApplyId: Base64.encode(row.invoiceApplyId)
        }
      })
      window.open(srcInfo.href, '_blank')
    },
    // 清空form
    resetDoSearch (data) {
      this.dataForm.companyIds = [this.$store.state.user.defaultCompanyId]
      this.getInquriyDataList()
    },
    handleSaveReceive () {
      this.$router.push({ path: '/personalCenter/order-invoice-add' })
    },
    getParams () {
      let params = {
        ...this.$refs.search.getParams(),
        page: this.dataForm.page,
        limit: this.dataForm.limit,
        companyIds: this.dataForm.companyIds
      }
      return params
    },
    // 导出
    download () {
      let dataForm = this.$refs.search.getParams()
      let url = '/front/oms/shopping/invoiceApply/v1/invoiceListExport'
      this.loading = true
      const obj = {
        ...dataForm,
        frontSource: 'webShop',
        companyIds: this.dataForm.companyIds
      }
      this.$http
        .post(url, obj)
        .then(({ data: res }) => {
          this.loading = false
          if (res.code !== 0) {
            return
          }
          this.$message.success('文件生成中,请稍后在导出历史中查看')
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.inquiry_list {
  width: 100%;
  background: white;
  padding: 16px;
  display: flex;
  flex-direction: column;
  position: relative;
  ::v-deep .search-list {
    .item {
      width: 33.33%;
      &.search-btns {
        order: 3;
      }
    }
  }
  .title_row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .inquiry-tab-item {
    display: inline-block;
    margin-left: 10px;
    text-align: center;
    background: #ffffff;
    height: 35px;
    line-height: 35px;
    font-size: 14px;
    letter-spacing: 0;
    margin-right: 24px;
    cursor: pointer;
  }
  .tab-item-active {
    color: #1d65a8;
    border-bottom: 2px solid #1d65a8;
  }
  .tooltip-content {
    max-width: 500px;
    text-align: center;
    border-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .back_content {
    color: #fff;
    background: rgba(0, 0, 0, 0.5);
  }
}
/deep/ .el-input__icon {
  height: 30px;
  line-height: 30px;
}
/deep/ .el-date-editor .el-range__icon {
  line-height: 30px;
}
.table {
  display: flex;
  flex: 1;
  flex-direction: column;
}
.operatBox {
  position: absolute;
  right: 24px;
  top: 16px;
}
</style>
